import _extends from "@babel/runtime-corejs2/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/objectWithoutProperties";
var _excluded = ["translator", "assetPath", "locale", "backLink"];
import * as React from 'react';
import { Button } from '@gandi/ui';
import { Static } from '../Static';
function Maintenance(_ref) {
  var __ = _ref.translator.__,
    assetPath = _ref.assetPath,
    locale = _ref.locale,
    backLink = _ref.backLink,
    extraProps = _objectWithoutProperties(_ref, _excluded);
  return (
    /*#__PURE__*/
    // $FlowFixMe[cannot-spread-inexact]
    React.createElement(Static, _extends({
      title: __('Maintenance in progress'),
      illustration: assetPath('img/Maintenance.svg'),
      buttons: backLink && /*#__PURE__*/React.createElement(Button, {
        href: backLink
      }, __('Return to homepage'))
    }, extraProps), /*#__PURE__*/React.createElement("p", null, __('We are currently doing maintenance work on the service ' + 'you requested.')), /*#__PURE__*/React.createElement("p", null, __('Please try again at a later moment.')), /*#__PURE__*/React.createElement("p", {
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML: __('You can also access  ' + '<a href="https://status.gandi.net">status.gandi.net</a> ' + 'for more information about the current state of our plateform.', {
        withHTML: true
      })
    }))
  );
}
export default Maintenance;